import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useStore } from 'models/stores';

function toSelectObject<T extends string>(list: Array<T>) {
  return list.reduce((result, item) => {
    result[item] = true;
    return result;
  }, {} as Record<(typeof list)[number], boolean>);
}
export function useEnterpriseFilters(jobs: any) {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    uiStore: { t },
  } = useStore();
  const [searchValue, setSearchValue] = useState('');

  const searchString = searchValue.toLowerCase().trim().replace(new RegExp(' ', 'g'), '');
  const departments = searchParams.getAll('department');
  const statuses = searchParams.getAll('status');

  const statusTypes = useMemo(() => {
    return [
      { value: 'full_time', display: t('jobStatus_full_time') },
      { value: 'part_time', display: t('jobStatus_part_time') },
    ];
  }, [t]);

  const departmentsObj = useMemo(() => toSelectObject(departments), [departments]);
  const statusesObj = useMemo(() => toSelectObject(statuses), [statuses]);

  function selectDepartment(department: Record<string, boolean>) {
    setSearchParams({
      department: Object.keys(department).filter((key) => department[key]),
      status: statuses,
    });
  }

  function selectStatus(status: Record<string, boolean>) {
    setSearchParams({
      status: Object.keys(status).filter((key) => status[key]),
      department: departments,
    });
  }

  return {
    departmentsObj,
    searchString,
    selectDepartment,
    selectStatus,
    selectedDepartments: departments,
    selectedStatuses: statuses,
    searchValue,
    setSearchValue,
    statusTypes,
    statusesObj,
  };
}
